import { createAction, props } from '@ngrx/store';
import { Corporation, FacilityStructure } from '../../../models/rpm/corporation.model';
import {ReportData} from "../../../models/rpm/monthly-notification.model";

export const addCorporations = createAction(
    '[RPM Page] Add corporations',
    props<{ corporations: Corporation[] }>()
  );

export const addFacility = createAction(
  '[RPM Page] Add facility',
  props<{ facility: FacilityStructure }>()
);

export const addPatientReport = createAction(
  '[Patient] Add Patient Report',
  props<{ reportId: string, report: ReportData }>()
);
